// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__96HHa","label":"styles_label__BWu52","actions":"styles_actions__2xRBW","button":"styles_button__1Mlsh","loading":"styles_loading__3IVks"};